import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
    
  @media (max-width: 979px) {
    margin-left: 12px;
    margin-right: 12px;
  }
`;

export const SmallTitle = styled.span`
  display: block;
  line-height: 140%;
  font-size: 16px;
  margin-top: 155px;
  margin-bottom: 14px;

  @media (max-width: 979px) {
    margin-top: 80px;
    font-size: 13px;
  }
`;

export const MainTitle = styled.h1`
  font-family: "Cormorant Infant", sans-serif;
  font-weight: 600;
  font-size: 45px;
  text-align: center;
  line-height: 105%;
  margin-bottom: 36px;
    
    span {
      color: #F4502F;
    }

  @media (max-width: 979px) {
    font-size: 38px;
  }
`

export const Text = styled(SmallTitle)`
  font-size: 18px;
  margin-bottom: 36px;
  margin-top: 0;
  text-align: center;

  @media (max-width: 979px) {
    font-size: 15px;
  }
`

